import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { getTranslation, getSidebarOpened } from '@/store/getters'
import { toggleSidebar } from '@/store/actions'
import { MagazineConsumer } from '@/contexts/magazine'

import styles from './styles.scss'

/** Components */
import { elementTypes } from '@/components/commons/editor/configs/ElementTypes'
import ShapeComponent from '../Shapes'
// import PageOrder from '../PageOrder'
import Layers from '../Layers'
import ZoomControl from '../ZoomControl/index'

import ContentEditor from '../../components/ContentEditor'
import IconComponent from '../../../../components/commons/IconComponent'

const Sidebar = props => {

  const { translation, toggleSidebar, sidebarOpened } = props
  const { isOpened, name } = sidebarOpened

  // const [showMenu, setShowMenu] = useState(true)

  useEffect(() => {
    handleLayer()
  }, [])

  const handleLayer = () => {
    toggleSidebar({
      isOpened: true,
      name: 'layers'
    })
  }

  const handleToggle = () => {
    toggleSidebar({
      isOpened: !isOpened,
      name: 'layers'
    })
  }



  return (
    <MagazineConsumer>
      {({ onAddElement }) => (
        <div className={'ba-bg-white1 ' + styles['wrapper-sidebar'] + ' ' + (isOpened ? styles['show'] : styles['hide'])}>
          <span className={"ba-montserrat-700 " + styles['ba-subtitle']}>{translation('sidebar-magazine-subtitle')}</span>

          <div className={"ba-rounded ba-btn ba-sm ba-bg-white1 " + styles['float-button'] + ' ' + (isOpened ? styles['show'] : styles['hide'])}>
            <button className={"ba-btn ba-blue ba-rounded " + styles['minimal']} onClick={handleToggle}>
              {isOpened ? <builderall-icon code='arrow-right' /> : <builderall-icon code='arrow-left' />}
            </button>
          </div>

          <div className="ba-flex ba-jc-sa ba-mg-t-1">

            <button className='ba-btn ba-btn-normal ba-sm ba-rounded'
              onClick={() => onAddElement(elementTypes.TEXT)}
              tooltip={translation('editor-button-add-text')}
              tooltip-position="bottom"
            >
              <builderall-icon code='d789'></builderall-icon>
            </button>

            <button className='ba-btn ba-btn-normal ba-sm ba-rounded'
              onClick={() => onAddElement(elementTypes.IMAGE)}
              tooltip={translation('editor-button-add-image')}
              tooltip-position="bottom"
            >
              <builderall-icon code='fb36'></builderall-icon>
            </button>

            <button className='ba-btn ba-btn-normal ba-sm ba-rounded'
              onClick={() =>
                toggleSidebar({
                  isOpened: true,
                  name: 'shapes'
                })
              }
              tooltip={translation('editor-button-add-shape')}
              tooltip-position="bottom"
            >
              <builderall-icon code='12cd'></builderall-icon>
            </button>

            <button className='ba-btn ba-btn-normal ba-sm ba-rounded'
              onClick={() => onAddElement(elementTypes.VIDEO)}
              tooltip={translation('editor-button-add-video')}
              tooltip-position="bottom"
            >
              <builderall-icon code='2bc8'></builderall-icon>
            </button>

            <button className='ba-btn ba-btn-normal ba-sm ba-rounded'
              onClick={() => onAddElement(elementTypes.IFRAME)}
              tooltip={translation('editor-button-add-iframe')}
              tooltip-position="bottom"
            >
              <IconComponent icon='close-tag' />
              {/* <builderall-icon code='5fa9'></builderall-icon> */}
            </button>
          </div>

          <div className="ba-flex ba-jc-sb ba-mg-y-1">
            <button
              className={"ba-montserrat-600 ba-btn ba-w-50 "
                + (name === 'layers' ? 'ba-bg-light18 ba-color-blue1' : 'ba-bg-white1 ba-bg-hover-light19 ba-color-black15 ba-color-hover-blue1')}
              onClick={handleLayer}
            >
              {translation('general-layers')}
            </button>
            <button
              className={"ba-montserrat-600 ba-btn ba-w-50 "
                + (name !== 'layers' ? 'ba-bg-light18 ba-color-blue1' : 'ba-bg-white1 ba-color-black15')}
            >
              {translation('general-formating')}
            </button>
          </div>

          <ShapeComponent onAddElement={onAddElement} />
          {name === 'layers' ? (<Layers />) : (<ContentEditor />)}

          {/* <PageOrder /> */}
          <ZoomControl />
        </div>

      )}

    </MagazineConsumer>
  )
}

const mapStateToProps = state => {
  const translation = getTranslation(state)
  const sidebarOpened = getSidebarOpened(state)
  return { translation, sidebarOpened }
}

export default connect(
  mapStateToProps,
  { toggleSidebar }
)(Sidebar)



// WEBPACK FOOTER //
// ./src/pages/Editor/components/Sidebar/index.js